import {fxgDataMap} from '@/servers/prod/center/fxg.js'
import {_formatGoodsItem as ksDataMap} from '@/servers/prod/center/kuaishou.js'
import {pddDataMap} from '@/servers/prod/center/pdd.js'
import {_formatGoodsItem as alibabaDataMap} from '@/servers/prod/center/alibaba.js'
import {_formatGoodsItem as wxhDataMap} from '@/servers/prod/center/wxh.js'
import {_formatGoodsItem as xhsDataMap} from '@/servers/prod/center/xhs.js'
import {_formatGoodsItem as tbDataMap} from '@/servers/prod/center/tb.js'
import {_formatGoodsItem as tmDataMap} from '@/servers/prod/center/tm.js'
import {_formatGoodsItem as jdDataMap} from '@/servers/prod/center/jd.js'
import {  _formatGoodsItem as yzDataMap} from '@/servers/prod/center/yz.js'
import {  _formatGoodsItem as xyDataMap} from '@/servers/prod/center/xianyu.js'
// 任务状态
export const TASK_STATUS = {
    'PENDING':'待执行',
    'RUNNING':'执行中',
    'AI_IMAGE_RUNNING':'AI生图中',
    'COMPLETED':'已完成',
    'FAILED':'任务失败',
}
// 任务状态class
export const TASK_CLASS = {
    'PENDING':'grey',
    'RUNNING':'orangeText',
    'AI_IMAGE_RUNNING':'orangeText',
    'COMPLETED':'greenText',
    'FAILED':'redText',
}
// 铺货状态
export const PUBLISH_STATUS = {
    'NOT_DISTRIBUTED':'未铺货',
    'DISTRIBUTED':'已铺货',
    'DISTRIBUTION_FAILED':'铺货失败',
}
// 铺货状态class
export const PUBLISH_STATUS_CLASS = {
    'NOT_DISTRIBUTED':'redText',
    'DISTRIBUTED':'greenText',
    'DISTRIBUTION_FAILED':'redText',
}
// 任务类型
export const BIZ_TYPE = {
    'GOODS_FISSION':'商品裂变',
}

export const PLATFORM_DATA_FORMAT = {
    'tb':tbDataMap,
    'tm':tmDataMap,
    'fxg':fxgDataMap,
    'jd':jdDataMap,
    'kuaishou':ksDataMap,
    'pdd':pddDataMap,
    '1688':alibabaDataMap,
    'wxsph':wxhDataMap,
    'xhs':xhsDataMap,
    'yz':yzDataMap,
    'xy':xyDataMap,
}